import { Carousel } from 'react-bootstrap';

import "./PublicLandingHeader.css"


export default function PublicLandingHeader() {
    return (
        <div className='top-header'>
            <Carousel
                className='small'
                style={{
                    minWidth: "400px", 
                    width: "33%", 
                    justifySelf: "center"
                }}
                prevIcon={
                    <span
                        className="carousel-control-prev-icon"
                        style={{
                            width: "1rem",
                            height: "1rem",
                            backgroundSize: "100% 100%",
                        }}
                    />
                }
                nextIcon={
                    <span
                        className="carousel-control-next-icon"
                        style={{
                            width: "1rem",
                            height: "1rem",
                            backgroundSize: "100% 100%",
                        }}
                    />
                }>
                <Carousel.Item>
                    <div className='text-light-top-header'>
                        A queridinha dos famosos
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='text-light-top-header'>
                        Seja um Franqueado
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='text-light-top-header'>
                        Estamos em todo o Brasil
                    </div>
                </Carousel.Item>
                <Carousel.Item>
                    <div className='text-light-top-header'>
                        Estamos em PE, PA, PB, SP, ES, SC e RJ
                    </div>
                </Carousel.Item>
            </Carousel>
        </div>
    );
}